import { Session } from './Session';

/**
 * Feature ID mapping for routes
 * These IDs should match the _id field in Session.metadata.enabledFeatures array
 */
export const FEATURE_IDS = {
  SHORTLISTING_GENIE: 'nhss',
  INTERVIEW_WIZARD: 'vewI',
  BLOG: 'llgl', 
};

/**
 * Check if a feature is enabled for the current user
 * @param {string} featureId - The feature ID to check
 * @returns {boolean} - True if feature is enabled, false otherwise
 */
export const isFeatureEnabled = (featureId) => {
  const metadata = Session.getClientMetadata();
  const enabledFeatures = metadata?.enabledFeatures;

  if (enabledFeatures === null || enabledFeatures === undefined) {
    return true;
  }

  if (!Array.isArray(enabledFeatures) || enabledFeatures.length === 0) {
    return false;
  }
  if (typeof enabledFeatures[0] === 'string') {
    return enabledFeatures.includes(featureId);
  }

  return enabledFeatures.some((feature) => feature._id === featureId);
};

/**
 * Get all enabled feature IDs
 * @returns {string[]} - Array of enabled feature IDs
 */
export const getEnabledFeatureIds = () => {
  const metadata = Session.getClientMetadata();
  const enabledFeatures = metadata?.enabledFeatures || [];

  if (enabledFeatures.length === 0) {
    return [];
  }
  if (typeof enabledFeatures[0] === 'string') {
    return enabledFeatures;
  }
  return enabledFeatures.map((feature) => feature._id);
};
